import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { useI18n } from "utils/with-i18n.utils";

export const CatalogHeader = () => {
  const i18n = useI18n();
  const router = useRouter()
  const {tags, selectedTagState: [selectedTag]} = useCatalogPageContext();

  const [descriptionIsExpanded, setDescriptionIsExpanded] = useState(true);
  // This shows entire description for seo
  useEffect(() => setDescriptionIsExpanded(false), []);

  const slugPath = router.query.slug
  
  const defaultTitle = 
    slugPath === 'legacy' ? i18n.t("catalog.legacySection.title") :
    slugPath === 'prochainement' ? i18n.t("catalog.comingSoonSection.title") :
    slugPath === 'meilleures-ventes' ? i18n.t("catalog.bestSellersSection.title") :
    i18n.t("catalog.availableSection.title");
  const tagTitle = tags.find(({ slug }) => slug === selectedTag)?.title;
  const pageTitle = tagTitle || defaultTitle;

  const defaultDescription =
    slugPath === 'legacy' ? i18n.t("catalog.legacySection.subtitle") :
    slugPath === 'prochainement' ? i18n.t("catalog.comingSoonSection.subtitle") :
    slugPath === 'meilleures-ventes' ? i18n.t("catalog.bestSellersSection.subtitle") :
    i18n.t("catalog.availableSection.description");
  const tagDescription = tags.find(({ slug }) => slug === selectedTag)?.description;
  const pageDescription = tagDescription || defaultDescription;

  return (
    <div className="flex flex-col gap-1 sm:gap-2">
      {/* Title */}
      <h1 className="text-2xl font-semibold sm:text-3xl">{pageTitle}</h1>

      {/* Description */}
      {pageDescription && (
        <>
          {/* Description desktop */}
          <p className="hidden max-w-840 text-xs font-light text-black/80 sm:block sm:text-sm">
            {pageDescription.slice(0, descriptionIsExpanded ? undefined : 200)}
            {pageDescription.length > 200 && (
              <span
                className="ml-1 font-medium text-black underline cursor-pointer"
                onClick={() => setDescriptionIsExpanded(!descriptionIsExpanded)}
              >
                  {descriptionIsExpanded ? i18n.t('common.readLess') : i18n.t('common.readMore')}
              </span>
            )}
          </p>

          {/* Description mobile */}
          <p className="max-w-840 text-xs font-light text-black/80 sm:hidden sm:text-sm">
            {pageDescription.slice(0, descriptionIsExpanded ? undefined : 100)}
            {pageDescription.length > 100 && (
              <span
                className="ml-1 font-medium text-black underline cursor-pointer"
                onClick={() => setDescriptionIsExpanded(!descriptionIsExpanded)}
              >
                  {descriptionIsExpanded ? i18n.t('common.readLess') : i18n.t('common.readMore')}
              </span>
            )}
          </p>
        </>
      )}
    </div>
  );
};
